<template>
  <div class="pa-4">
    <div>
      <div>{{ index }}. {{ question.title }}</div>
      <div style="font-size: 12px">{{ question.countReply || 0 }} câu trả lời</div>
    </div>
    <apexchart v-if="!loading" width="400" type="pie" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          width: 400,
          type: 'pie'
        },
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'left'
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              }
            }
          }
        ]
      }
    }
  },
  mounted() {
    const labels = this.question.answers.map(answer => answer.title)
    const series = this.question.answers.map(answer => answer.countChoice)
    this.chartOptions.labels = labels
    this.series = series
    this.loading = false
  }
}
</script>

<style></style>
